// extracted by mini-css-extract-plugin
export var heading1 = "styles-module--heading1--1sIMK";
export var heading2 = "styles-module--heading2--3LGJ1";
export var heading3 = "styles-module--heading3--3gZjM";
export var body1 = "styles-module--body1--3CDfD";
export var body2 = "styles-module--body2--i2MbP";